module.exports = __webpack_public_path__ + "img/i_copyright_new.5e1afaf4.jpg";